import { css } from 'styled-components';
export var applyMaxLines = function applyMaxLines(_ref) {
  var maxLines = _ref.maxLines;
  return maxLines && css(["display:-webkit-box;overflow:hidden;box-sizing:border-box;white-space:normal;-webkit-box-orient:vertical;-webkit-line-clamp:", ";"], maxLines);
};